/* istanbul ignore next */
export { default } from './ModalTemplate';
